export const INSURANCE = {
  DUE_PAYMENT: 'insurance_missing_occurrence',
  POST_PURCHASE: 'insurance-post-purchase',
  EXPIRED: 'insurance-post-purchase-expired',
}
